<template>
<div>
	<h3>{{ $t('MAIN_CONTENT.Devices.manageDevices') }}</h3>
	<div>
		<p>{{ $t('MAIN_CONTENT.Devices.devicesDescription1Part1') }} <b>{{ $t('MAIN_CONTENT.Devices.rememberMe') }}</b> {{ $t('MAIN_CONTENT.Devices.devicesDescription1Part2') }}</p> 
		<p>{{ $t('MAIN_CONTENT.Devices.devicesDescription2') }}</p> 
	</div>
	<div class="alert alert-info" v-if="devices.length === 0">
		<p>{{ $t('MAIN_CONTENT.Devices.noDevicesMessage') }}</p>
	</div>
	<div class="row" v-if="devices.length > 0">
		<div class="col-md-3 hidden-sm hidden-xs">
			<h4>{{ $t('MAIN_CONTENT.Devices.device') }}</h4>
		</div>
		<div class="col-md-3 hidden-sm hidden-xs">
			<h4>{{ $t('MAIN_CONTENT.Devices.activeSince') }}</h4>
		</div>
		<div class="col-md-3 hidden-sm hidden-xs">
			<h4>{{ $t('MAIN_CONTENT.Devices.lastUsed') }}</h4>
		</div>
		<div class="col-md-3 hidden-sm hidden-xs">
			&nbsp;
		</div>
	</div>
	<div class="panel panel-default" v-for="device in devices">
  	<div class="panel-body">
			<div class="col-md-3">
    		<h5>{{device.DEVICE_NAME}}</h5>
			</div>
			<div class="col-md-3">
				<h5>{{ $t('MAIN_CONTENT.Devices.activeSince') }} {{device.ISSUED_AT | datetime}}</h5>
			</div>
			<div class="col-md-3">
				<h5>{{ $t('MAIN_CONTENT.Devices.lastUsedAt') }} {{device.LAST_USED_AT | datetime}}</h5>
			</div>
			<div class="col-md-3 text-right">
				<a href="javascript: void(0);" @click="logoutDevice(device.PERSISTENT_LOGIN_GUID)" class="btn btn-sm btn-danger">{{ $t('MAIN_CONTENT.Devices.logOutDevice') }}</a>
			</div>
  	</div>
	</div>
</div>
</template>

<script>
	import Device from '../../api/Device';

	export default {
		data(){
			return {
				devices: [],
			}
		},
		methods:{
			fetchDevices(){
				const self = this;
				let device = new Device();

				const promise = device.get();
				promise.then(response => {
					self.devices = device.getResponseData();
				});
			},
			logoutDevice(persistentLoginGUID){
				const self = this;
				const messageText = this.$t('MAIN_CONTENT.Devices.confirmLogoutMessage');
				this.$dialog.confirm(messageText, { okText: this.$t('MAIN_CONTENT.Header.logoutHeaderLabel'), cancelText: this.$t('commonText.cancel')}).then(ans => {
					if( ans ){
						let device = new Device({
							routeParams: { persistentLoginGUID: persistentLoginGUID }
						});

						const promise = device.delete();
						promise.then(response => {
							self.fetchDevices();
						});
					}
				});

			}
		},
		created(){
			this.$store.commit('setTitleIcon', 'laptop');
			this.$store.commit('setTitle', this.$t('MAIN_CONTENT.Devices.devices'));
			this.$store.commit('setUseHeader', true);
			this.fetchDevices();
		}
	}
</script>
